<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">

            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable/>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable/>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.deptCode" filterable placeholder="系部" clearable
                               @change="changeOption('dept')">
                        <el-option v-for="item in comboData.dept" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.majorCode" filterable placeholder="专业" clearable
                               @change="changeOption('major')">
                        <el-option v-for="item in comboData.major" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.gradeCode" filterable placeholder="年级" clearable
                               @change="changeOption('grade')">
                        <el-option v-for="item in comboData.major" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.classCode" filterable placeholder="班级" clearable>
                        <el-option v-for="item in comboData.class" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.auditState" placeholder="审核状态(全部)" clearable>
                        <el-option v-for="(item, index) in comboData.auditState" :key="item.comboValue" :value="item.comboValue"
                                   :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll" :style="{'height': divHeight-110+'px','overflow': 'auto'}">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有自主联系申请记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓名：</label>{{ item.stuName }}</p>
                        <p><label for="">系部：</label>{{ item.deptName }}</p>
                        <p><label for="">专业：</label>{{ item.majorName }}</p>
                        <p><label for="">班级：</label>{{ item.className }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput">
                        <el-button v-if="item.submitState=='1' && item.auditAuth=='0' || item.auditState=='2'" size="small"
                                   @click="showDetailInfo(item);" type="info">详情
                        </el-button>
                        <el-button v-if="item.auditAuth == '1'" size="small"
                                   @click="auditRec(item);" type="primary">审核
                        </el-button>
                        <el-button
                            v-if="item.submitState=='1' || item.auditState=='1'|| item.auditState=='2'"
                            size="small"
                            @click="showAuditList(item);">审核信息
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" title="详情" :visible.sync="detailDialogVisible"
                       v-if="detailDialogVisible" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form label-width="130px" label-position="left" width="100%">
                        <el-form-item label="学生">
                            {{ selectRowData.stuName }} - {{ selectRowData.stuCode }}
                        </el-form-item>
                        <el-form-item label="实习单位名称">
                            {{ selectRowData.unitName }}
                        </el-form-item>
                        <el-form-item label="实习岗位名称">
                            {{ selectRowData.postName }}
                        </el-form-item>
                        <el-form-item label="实习开始时间">
                            {{ selectRowData.beginTime }}
                        </el-form-item>
                        <el-form-item label="实习结束时间">
                            {{ selectRowData.endTime }}
                        </el-form-item>
                        <el-form-item label="实习薪资">
                            {{ selectRowData.salary }}
                        </el-form-item>
                        <el-form-item label="单位联系人姓名">
                            {{ selectRowData.unitContactsName }}
                        </el-form-item>
                        <el-form-item label="单位联系人职务">
                            {{ selectRowData.unitContactsDuty }}
                        </el-form-item>
                        <el-form-item label="单位联系人电话">
                            {{ selectRowData.unitContactsTel }}
                        </el-form-item>
                        <el-form-item label="单位联系人邮箱">
                            {{ selectRowData.unitContactsEmail }}
                        </el-form-item>
                        <el-form-item label="单位地址">
                            {{ selectRowData.unitAddress }}
                        </el-form-item>
                        <el-form-item label="岗位是否对口">
                            {{ parseSf(selectRowData.counterpart) }}
                        </el-form-item>
                        <el-form-item label="是否安排带教">
                            {{ parseSf(selectRowData.teaching) }}
                        </el-form-item>
                        <el-form-item label="是否提供住宿">
                            {{ parseSf(selectRowData.putUp) }}
                        </el-form-item>
                        <el-form-item label="入学前户籍信息">
                            {{ selectRowData.censusRegisterInfo }}
                        </el-form-item>
                        <el-form-item label="实习期间居住地址">
                            {{ selectRowData.residentialAddress }}
                        </el-form-item>
                        <el-form-item label="家庭电话">
                            {{ selectRowData.homeTel }}
                        </el-form-item>
                        <el-form-item label="学生手机号">
                            {{ selectRowData.stuPhone }}
                        </el-form-item>
                        <el-form-item label="学生邮箱">
                            {{ selectRowData.stuEmail }}
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <audit v-if="auditAreaVisible" ref="audit" :itemCode="auditParam" :relatedCode="selectRowData.id" style="padding-bottom: 10px"
                       :auditLevel="selectRowData.auditLevel" @auditCallback="auditCallback"/>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible"
                       v-if="auditListDialogVisible" width="90%">
                <div>
                    <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450"></auditList>
                </div>
            </el-dialog>


        </div>
    </div>
</template>

<script>
import {globalConfig} from "../../../../static/config";
import audit from 'views/mobile/audit.vue';
import auditList from 'views/mobile/auditList.vue';
import {showNotify} from "../../../utils/message";

export default {
    props: ['divHeight'],
    components: {
        audit,
        auditList,
    },
    data() {
        return {
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                userCode: '',
                userRoles: [],
                majorCode: '',
                gradeCode: '',
                classCode: '',
                deptCode: '',
                itemCode: '',
                auditState:''
            },
            //表格数据
            tableData: [],
            //选中行的数据
            selectRowData: null,
            tableLoading: true,
            total: null,
            currentPage: 1,
            mainTableHeight: 500,
            comboData: {
                major: [],
                grade: [],
                class: [],
                dept: [],
                auditState:[]
            },
            queryDialogVisible: false,
            detailDialogTitle:'',
            detailDialogVisible:false,
            auditAreaVisible:false,
            auditListDialogVisible:false,
            auditParam: null,
        }

    },
    mounted() {
        this.queryForm.userCode = this.userCode
        this.queryForm.userRoles = this.userRoles
        this.userInfo()
        this.initCombo()
    },
    methods: {
        auditRec(rowData) {
            this.selectRowData = rowData;
            this.detailDialogTitle = '审核';
            this.detailDialogVisible = true;
            this.auditAreaVisible = true;
        },
        //完成审核后更新审核状态
        updateAuditState(auditInfo) {
            const paramMap = {
                'id': this.selectRowData.id,
                'stuCode': this.selectRowData.stuCode,
                'stuName': this.selectRowData.stuName,
                'censusRegisterInfo': this.selectRowData.censusRegisterInfo,
                'residentialAddress': this.selectRowData.residentialAddress,
                'homeTel': this.selectRowData.homeTel,
                'stuPhone': this.selectRowData.stuPhone,
                'stuEmail': this.selectRowData.stuEmail,
                'unitName': this.selectRowData.unitName,
                'postName': this.selectRowData.postName,
                'beginTime': this.selectRowData.beginTime,
                'endTime': this.selectRowData.endTime,
                'salary': this.selectRowData.salary,
                'counterpart': this.selectRowData.counterpart,
                'teaching': this.selectRowData.teaching,
                'putUp': this.selectRowData.putUp,
                'unitContactsName': this.selectRowData.unitContactsName,
                'unitContactsDuty': this.selectRowData.unitContactsDuty,
                'unitContactsEmail': this.selectRowData.unitContactsEmail,
                'unitAddress': this.selectRowData.unitAddress,
                'unitContactsTel': this.selectRowData.unitContactsTel,
                'itemCode': auditInfo.itemCode,
                'auditState': auditInfo.auditState,
                'auditLevel': auditInfo.auditLevel,
                'userCode': this.queryForm.userCode,
            };

            this.$api.postPracticeManage.autonomouslyApply.updateAuditState({
                data: paramMap,
            }).then((response) => {
                let state = response.data.data.state;
                if (state === 'Success') {
                    this.requeryList();
                } else {
                    showNotify('失败', '审核状态更新失败', 'error', 3000);
                }
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        //查询审核调用参数
        queryAuditParam() {
            // const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/") + 1);
            const pageName = 'autonomouslyApply'

            this.$api.common.audit.auditParam({
                data: {
                    pageName: pageName
                },
            }).then((res) => {
                this.auditParam = res.data.data.auditParam;
                this.queryForm.itemCode = this.auditParam;
                this.queryList();
            }).catch((err) => {
                console.log(err);
            });
        },
        //审核后回调函数
        auditCallback(auditInfo) {
            this.detailDialogVisible = false;

            this.updateAuditState(auditInfo);
        },
        //显示审核详情列表
        showAuditList(rowData) {
            this.selectRowData = rowData;
            this.auditListDialogVisible = true;
        },
        showDetailInfo(rowData) {
            this.selectRowData = rowData;
            this.detailDialogTitle = '详情';
            this.detailDialogVisible = true;
            this.auditAreaVisible = false;
        },
        loadStateImg(row) {
            if (row.auditState === '1') {
                return require('image/mobile/auditState/tg.png');
            } else if (row.auditState === '2') {
                return require('image/mobile/auditState/bh.png');
            } else {
                if (row.submitState === '1') {
                    if (row.auditLevel === '1') {
                        return require('image/mobile/auditState/dsh.png');
                    } else {
                        return require('image/mobile/auditState/shz.png');
                    }
                } else {
                    return require('image/mobile/auditState/wtj.png');
                }
            }
        },
        userInfo() {
            this.$api.system.basic.userInfo({})
                .then((res) => {
                    this.queryForm.userCode = res.data.data.phone;
                    let arr = []
                    for (let roleCode in res.data.data.roles) {
                        if (roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.jwy_sx || roleCode === globalConfig.auth.fdy || roleCode === globalConfig.auth.sx_xbgly || roleCode === globalConfig.auth.sx_zyzdjs) {
                            arr.push(roleCode)
                        }
                    }
                    this.queryForm.userRoles = arr
                    // this.queryForm.userCode = '096136'
                    // this.queryForm.userRoles = []
                    // this.queryForm.userRoles.push(globalConfig.auth.jwy_sx)
                    // this.queryForm.userRoles.push('7')
                    // this.queryForm.userRoles.push('22')
                    // this.queryForm.userRoles.push('21')

                    this.queryAuditParam()
                }).catch((err) => {
                console.log(err);
            });
        },
        changeOption(type) {
            this.queryForm.classCode = ''
            let param = {}
            param = {
                "deptCode": this.queryForm.deptCode,
                "majorCode": this.queryForm.majorCode
            }

            if (type === 'dept') {
                this.queryForm.majorCode = ''
                this.$api.common.comboOption.major({
                    data: param
                }).then((res) => {
                    this.comboOption.major = res.data.data.comboData
                }).catch((err) => {
                    console.log(err);
                });
            }

            this.$api.common.comboOption.class({
                data: param
            }).then((res) => {
                this.comboOption.class = res.data.data.comboData
            }).catch((err) => {
                console.log(err);
            });
        },
        async queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;

            await this.$api.postPracticeManage.autonomouslyApply.queryList({
                data: this.queryForm,
            }).then((response) => {
                this.total = response.data.data.total;
                this.tableData = this.tableData.concat(response.data.data.list);
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        initCombo() {
            this.$api.postPracticeManage.autonomouslyApply.initData({})
                .then((res) => {
                    this.comboData.major = res.data.data.major
                    this.comboData.grade = res.data.data.grade
                    this.comboData.class = res.data.data.class
                    this.comboData.dept = res.data.data.dept
                    this.comboData.auditState = res.data.data.auditState;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleFilter() {
            this.requeryList();
            this.queryDialogVisible = false;
        },
        requeryList() {
            this.scrollToTop();
            this.tableData.length = 0;
            this.currentPage = 1;
            this.queryList();
        },
        scrollToTop() {
            const ele = document.getElementById('listArea');
            if (ele) {
                ele.scrollTop = 0;
            }
        },
        handleReset() {
            this.queryForm.pageNum = 1;
            this.queryForm.rowNum = 20;
            this.queryForm.stuCode = '';
            this.queryForm.majorCode = '';
            this.queryForm.gradeCode = '';
            this.queryForm.classCode = '';
            this.queryForm.deptCode = '';
            this.queryForm.auditState = '';
            this.changeOption('dept')
            this.requeryList();
            this.queryDialogVisible = false;
        },
        handleScroll() {
            if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                this.currentPage++;
                this.queryList();
            }
        },
        checkVisible() {
            const ele = document.getElementById('loadingTips');
            if (ele) {
                let rect = ele.getBoundingClientRect();
                //获取当前浏览器的视口高度，不包括工具栏和滚动条
                //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                //bottom top是相对于视口的左上角位置
                //bottom大于0或者top-视口高度小于0可见
                return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
            } else {
                return false;
            }
        },
        submitStateFormatter(row) {
            return row.submitState === '1' ? '已提交' : '未提交';
        },
        auditStateFormatter(row) {
            let str = '';

            if (row.auditState === '1') {
                str = '通过';
            } else if (row.auditState === '2') {
                str = '驳回';
            } else {
                if (row.submitState === '1') {
                    if (row.auditLevel === '1') {
                        str = '待审核';
                    } else {
                        str = '审核中';
                    }
                } else {
                    str = '未提交';
                }
            }

            return str;
        },
        parseSf(str) {
            if (str === '1') {
                return '是'
            } else if (str === '0') {
                return '否'
            } else
                return ''
        },
        parseType(row) {
            if (row.typeCode === '1') {
                return '学校推荐'
            } else if (row.typeCode === '2') {
                return '自主联系'
            } else
                return ''
        }


    }
}
</script>

<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode {
    width: auto;
}

#mobileMode #queryDialog {
    top: 130px;
}

#mobileMode #mainDialogScroll {
    height: 60vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// autonomouslyApplyMobile.vue?e6120422